

<template>
  <div>
    <div  class="smart">
    <div class="search-input row">
<!--      <input placeholder="Поиск" type="text" autocomplete="off" class="search-input "  v-model="searchinput">-->
      <div class="col-11">
        <span v-if="search && search.length!=0"><b>{{search.length}}</b>
           <span v-for="(value,key) in search" >
            <span item v-if="value != ''" >
              <span class="search" @click="deletesearch(key)">
                <span class="searchleft">{{value}}</span>
                <span class="searchright"><i aria-hidden="true" class="fa fa-times"></i></span>
             </span>
            </span>
          </span>
        </span>
        <span v-else  @click="searchpanel()">
          Поиск
        </span>

      </div>
      <div class="col-1">
      <div class="ui-main" style="text-align: end">
        <a href="javascript:void(0);" class="ui-icon-search" @click="close=false"><i aria-hidden="true" class="fa fa-search"></i></a>
        <a href="javascript:void(0);" class="ui-icon-delete"  @click="close=true; deletesearchall()"><i aria-hidden="true" class="fa fa-times"></i></a>
      </div>
      </div>
    </div>

  </div>

	<div v-if="!close" class="bd-search">
    <div class="container row">
    <slot></slot>
    <br>

      <br>
      <br>
	</div>
	</div>

  </div>
</template>

<script>
	export default {
    props: [
       'title',
        // 'close'
    ],
    data () {
      return {
       // close_in: '',
        search: {},
        close: true
      }
    },
    methods: {
      deletesearch(key){
        this.search[key]='';
        this.$emit('search', {
          search: this.search,
        });
        this.$emit('my-event');
      },
      deletesearchall(){
        if (this.search && this.search.length>0){
        this.search.forEach(function callback(value, index) {
          this.search[index] = '';
        })

        this.$emit('search', {
          search: this.search,
        });
          }
        this.$emit('my-event');
      },
      closesearch(){
        this.close=true;
      },
      searchpanel(){
       if(this.close==true){
         this.close=false;
       }else{
         this.close=true;

       }
      },
      data(data){
        this.search=data;
      },
      submit(){
        var app = this;
        app.$emit('export-data', app.data);
      }
    },
    computed: {

    },
    watch: {
      'close': function(){
       // this.submit();
      }
    }
    }
</script>

<style>
.bd-search {
  position: absolute;
  /*padding: 1.25rem;*/
  margin-top: -0.1rem;
  margin-bottom: 1.25rem;
  border-right: 1px solid  #6c95d7;
  border-bottom: 1px solid  #6c95d7;
  border-left: 1px solid  #6c95d7;
  z-index: 10001;
  background: #fff;
  width: 100%;
  height: auto;
}
.bd-search .row{
  margin: 0;
  margin-left: 10%;
}
.bd-callout p:last-child {
  margin-bottom: 0;
}
.smart {
  position: relative;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  background-color: #fff;
  padding: 4px 4px 0 4px;
  border: 1px solid rgba(0, 0, 0, 0.1);
}
.search-input{
  border: none !important;
  padding: 0 53px 0 15px;
  /* width: 100%; */
  min-height: 36px;
  margin-bottom: 4px;
}
.ui-main {
  position: absolute;
  height: 100%;
  right: 3px;
  top: 0em;
  padding: 0 5px;
  width: 53px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}
.ui-main .ui-icon-search {
  position: absolute;
  right: 30px;
}
.ui-main .ui-icon-delete {
  right: 5px;
}

.ui-main .ui-icon-search, .ui-icon-delete{
  position: absolute;
  top: 0;
  width: 20px;
  height: 100%;
  line-height: 46px;
  color: #1e293d;
  opacity: 0.3;
  text-align: center;
}

.search-input {
  border: none !important;
  padding: 0 53px 0 15px;
  /* width: 100%; */
  min-height: 36px;
  margin-bottom: 4px;
}
.search{
  padding: 2px 30px;
  background: #ffcc99;
  font-size: 12px;
  border-radius: 6px;
  color: #2e2e2e;
}
.search:hover{
  background : #ecd8c2;
}
.searchright{
  position: relative;
  right: -2em;
}
.searchleft{
  position: relative;
  right: 1.5em;
}

</style>